import { render, staticRenderFns } from "./ShippingCalculatorPopup.vue?vue&type=template&id=2f0cd7ee&scoped=true"
import script from "./ShippingCalculatorPopup.vue?vue&type=script&lang=js"
export * from "./ShippingCalculatorPopup.vue?vue&type=script&lang=js"
import style0 from "./ShippingCalculatorPopup.vue?vue&type=style&index=0&id=2f0cd7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0cd7ee",
  null
  
)

export default component.exports